import React from 'react';
import styled from 'styled-components';
import ImpContainer from '../../Atoms/ImpContainer/ImpContainer';
import ImpFlex from '../../Atoms/ImpFlex/ImpFlex';
import ImpImage from '../../Atoms/ImpImage/ImpImage';
import ImpPad from '../../Atoms/ImpPad/ImpPad';
import { colors } from '../../DesignSystem/colors';
import ImpText from '../ImpText/ImpText';
export function ImpTile({ imageSrc, title, description, onClick, href, }) {
    const content = (React.createElement(ContentWrapper, { onClick: onClick },
        React.createElement(Image, { src: imageSrc, alt: title }),
        React.createElement(ImpContainer, { backgroundColor: colors.surface.surfaceHigh, borderRadius: "0 0 12px 12px" },
            React.createElement(ImpPad, { padding: "12px 16px", fluid: true },
                React.createElement(ImpFlex, { direction: "column", gap: "xs" },
                    React.createElement(ImpText, { typography: "label3", color: colors.content.onSurfaceVariant }, title),
                    React.createElement(ImpText, { typography: "body1" }, description))))));
    return href ? (React.createElement("a", { href: href, style: { textDecoration: 'none', color: 'inherit', width: '100%' } }, content)) : (content);
}
const ContentWrapper = styled.div `
  width: 100%;
  border-radius: 12px;
`;
const Image = styled(ImpImage) `
  width: 100%;
  height: 100px;
  border-radius: 12px 12px 0 0;
`;
//# sourceMappingURL=ImpTile.js.map